<template>
    <div class="sl-list-container"
         :class="{
             'sl-visible': !state.showMapOnMobile
         }">
        <ul v-if="locations.length" class="sl-list">
            <li v-for="location in locations"
                :key="location.id"
                class="sl-location"
                :class="getBorderType(location)"
                :data-id="location.id"
            >
                <location :location="location" />
            </li>
        </ul>

        <div v-if="!state.locations.length && !state.loading && state.hasSearched" class="sl-no-location">
            <strong>{{ errorBasedOnLocation }}</strong> Try adjusting your search distance 
            <div v-if="state.showVirtualFittingWithNoResults && state.searchType != 'retailers'">
                or explore our <a href="/virtual-fitting.html"> Virtual Fitting</a> options
            </div>
        </div>
    </div>
</template>

<script>
import Location from './Location';

export default {

    components: {
        Location
    },

    props: ['locations'],

    computed: {
        errorBasedOnLocation () {
            if (this.state.searchType == 'events') {
                return 'No upcoming events available.';
            }

            return 'No locations available';
        },
    },
    methods: {
        getBorderType (location) {
            if (location.events && location.events.length) {
                return 'mfe';
            }
            
            return location.iconType.toLowerCase();
        },
    }
};
</script>

<style scoped>
.sl-list {
    margin: 0;
    list-style: none;
    padding: 0;
}
@media (max-width: 999px) {
    .sl-list-container {
        display: none;
    }
    .sl-list-container.sl-visible {
        display: block;
    }
}
.sl-location {
    border-left: solid 3px #000;
    margin-bottom: 1px;
}

.sl-location.mfe {
    border-left: solid 3px #C02E1A;
}

.sl-location.core {
    border-left: solid 3px #98683B;
}

.sl-location.cert {
    border-left: solid 3px #8B8A8A;
}

.sl-location.prem {
    border-left: solid 3px #C09639;
}

.sl-no-location {
    text-align: center;
    padding-top: 25px;
    padding-bottom: 25px;
}
.sl-no-location strong {
    font-weight: 700;
    display: block;
    text-align: center;
    padding-bottom: 10px;
}
.sl-no-location a {
    text-decoration: underline;
}
.sl-no-location a:hover {
    text-decoration: none;
}
</style>
